
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import AuthHeader from "@/components/layout/auth-header.vue";
import SideLayout from "@/components/layout/SideLayout.vue";
import { Component, Vue } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import AiLogin from "@/content/aiLogin.vue";
import vuexStore from "@/store/vuex-store";
import request from "@/lib/request/request";
import Info from "@/lib/model/account/info";
import Store from "@/lib/common/Store";
import LoginFrom, { CodeForm } from "@/lib/form/login/LoginFrom";
import { ElForm } from "element-ui/types/form";
import ErrorPage from "@/views/error/404.vue";

@Component({
  components: {
    SideLayout,
    AuthHeader,
    AiLogin,
    ErrorPage
  }
})
export default class App extends Vue {
  needRegister = false;
  hasError = false; //报错页面
  errorText = "您的职位不在自动开通账号名单中，如需创建账号请与管理员联系";
  seconds = 0;
  interval = 0;
  codeForm: CodeForm = new CodeForm();
  loginFrom: LoginFrom = new LoginFrom();
  rules = this.loginFrom.rules();
  formElement!: ElForm;
  sendingCaptchaLock = false;
  loginLock = false;
  isSelected = false;
  locationOrigin = "";
  captchaLoginError = false;
  captchaErrorText = "";
  target = "/dash";
  isPC = true; //pc or 移动端
  h5LoginFinish = false;

  //设备查询
  isMobile(): boolean {
    const isIos = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
    const isAndroid = /(Android)/i.test(navigator.userAgent);
    return isIos || isAndroid;
  }

  register() {
    if (this.loginLock) {
      return;
    }
    if (!this.isChecked) return;
    if (this.loginLock) return;
    this.loginLock = true;

    this.captchaLoginError = false;
    if (!this.isSelected) {
      this.captchaErrorText = "请同意《海纳个人信息保护协议》";
      this.captchaLoginError = true;
      this.loginLock = false;
      return;
    }

    this.loginLock = true;
    return request
      .post("/aiExam/userAuth/submit", this.loginFrom)
      .then(resp => {
        const info = new Info().assign(resp.data.data);
        Auth.token = info.token;
        Auth.userId = info.userId;
        Store.getAccountStoreModule().then(module => {
          module.updateAccountInfo(info);
          this.loginFinish();
        });
      })
      .catch((err: any) => {
        this.captchaErrorText = err.message;
        this.captchaLoginError = false;
        this.onError(err.data.code, err.data.message);
      })
      .finally(() => {
        this.loginLock = false;
      });
  }

  onError(code: any, msg: string) {
    if (code == "201") {
      this.hasError = true;
      this.errorText = msg;
    }
  }

  get isChecked() {
    return (
      this.loginFrom.phone !== "" &&
      this.loginFrom.phone.length === 11 &&
      this.loginFrom.captcha !== "" &&
      this.loginFrom.captcha.length === 6
    );
  }

  get hasMobile() {
    return this.loginFrom.phone !== "" && this.loginFrom.phone.length === 11;
  }

  goHome() {
    this.$router.push({
      path: "/",
      query: this.$route.query
    });
  }

  checkMobileNumber(e: Event) {
    this.loginFrom.phone = (e.target as HTMLInputElement).value.replace(
      /[^\d]/g,
      ""
    );
  }

  getCode() {
    if (this.loginFrom.phone !== "" && this.loginFrom.phone.length === 11) {
      if (this.sendingCaptchaLock) {
        return;
      }
      if (this.seconds > 0) {
        return;
      }
      this.sendingCaptchaLock = true;
      // 获取验证码
      this.codeForm.phone = this.loginFrom.phone;
      request
        .post("aiExam/userAuth/sendCaptcha", this.codeForm)
        .then(() => {
          this.seconds = 60;
          this.interval = setInterval(() => {
            this.seconds--;
            if (this.seconds <= 0) {
              clearInterval(this.interval);
              this.sendingCaptchaLock = false;
            }
          }, 1000);
        })
        .catch((err: any) => {
          this.captchaErrorText = err.message;
          this.captchaLoginError = true;
        })
        .finally(() => {
          this.sendingCaptchaLock = false;
        });
    }
  }

  loginFinish() {
    //pc 跳到对应页面
    if (this.isPC) {
      if (this.target.indexOf("http") == 0) {
        location.href = this.target;
      } else this.$router.push(this.target);
    } else {
      //H5 展示空白文案
      this.h5LoginFinish = true;
    }
  }
  created() {
    this.isPC = !this.isMobile();
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    const params = {};
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split("=");
      params[pair[0]] = pair[1];
    }
    if (params["target"]) {
      this.target = decodeURIComponent(params["target"]);
    }

    if (params["hinaToken"]) {
      Auth.token = params["hinaToken"];
      this.loginFinish();
      return;
    }

    if (params["code"]) {
      request
        .post("/aiExam/userAuth/submit", {
          platform: params["app"],
          outUserToken: params["code"]
        })
        .then(resp => {
          if (resp.data.data.token) {
            const info = new Info().assign(resp.data.data);
            Auth.token = info.token;
            Auth.userId = info.userId;
            Store.getAccountStoreModule().then(module => {
              module.updateAccountInfo(info);
              this.loginFinish();
            });
          } else {
            this.needRegister = true;
            this.loginFrom["outUserToken"] = params["code"];
            this.loginFrom["platform"] = params["app"];
          }
        })
        .catch(err => {
          // this.$message.error("登录失败");
          this.onError(err.data.code, err.data.message);
        });
    } else {
      if (!params["app"]) params["app"] = "walmart";
      request
        .post("/aiExam/userAuth/jumpUrl", {
          platform: params["app"]
        })
        .then(resp => {
          location.href = resp.data.data.jumpUrl;
        })
        .catch(e => {
          this.$message.error("登录失败");
        });
    }

    console.log(params);
  }

  mounted() {
    //
  }
}
